import { UniqueIdentifier } from '@dnd-kit/core';

export const findContainer = (
  id: UniqueIdentifier,
  items: { [key: string]: any }
) => {
  if (Object.keys(items).includes(String(id))) {
    return id;
  }

  return Object.keys(items).find((key) =>
    items[key].find((item) => item.id === id)
  );
};
